module.exports = __webpack_public_path__ + "img/voice-thumb7.f7dceb3.jpg";